import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const OptionContainer = styled.div `
  padding: ${themeGet('spacing.sm')};
  border-radius: ${themeGet('borderRadius.lg')};
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
export const ReasonContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.xl')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.background.75')};
`;
